import baseAxios from 'axios';
import client from './client';
import { User } from '../types/user';

const WEBAPP_API_URL = process.env.REACT_APP_WEBAPP_API_URL || 'https://sozointuition.com';

export interface LoginResponse {
  access_token: string;
  token_type: string;
}

/**
 * Login:
 * 1. POST to Webapp for JWT
 * 2. POST JWT to Babbage for HttpOnly session cookie
 */
export const login = async (username: string, password: string): Promise<void> => {
  try {
    // 1. Authenticate with Webapp
    const webappResponse = await baseAxios.post(`${WEBAPP_API_URL}/api/auth/babbage/login`, {
      username,
      password,
    });

    const { access_token } = webappResponse.data;

    // 2. Exchange with Babbage to set the cookie
    await client.post('/api/v1/auth/token', {
      access_token,
    });
  } catch (error) {
    // If we are on localhost and the webapp login fails (e.g. CORS), try mock login
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      console.warn('External login failed, attempting local mock login (Dev Mode)');
      await client.post('/api/v1/auth/token', {
        access_token: 'mock-dev-token',
      });
    } else {
      throw error;
    }
  }
};

/**
 * Get current user information from Babbage API (uses session cookie automatically)
 */
export const getUserInfo = async (): Promise<User> => {
  const response = await client.get('/api/v1/users/me');
  return response.data;
};

/**
 * Logout: Call Babbage logout to clear the cookie
 */
export const logout = async (): Promise<void> => {
  await client.post('/api/v1/auth/logout');
  localStorage.removeItem('access_token'); // Just in case it was there
};
